import adapt from '@turnaroundfactor/common';
import { toast } from 'react-toastify';
import { updateSettings } from '@turnaroundfactor/react';

const TIMEOUT = 60000; // 60 seconds

let timer = null;

// Run when offline for more than TIMEOUT.
function handleOfflineState() {
  if ( timer ) clearTimeout(timer);
	timer = null;
  adapt.trigger('OFFLINE');
  try{
    toast.dismiss('network_offline');
  }catch(e){}
}

export default function onlineState(event){
  // setup timer when disconnected from the internet.
  if ( event.type === 'offline' ){
		if (timer === null) {
			console.log('Setup network timer due to lost connection.');
    	timer = setTimeout(handleOfflineState, TIMEOUT);
		}

    adapt.trigger('SERVICE_DISRUPTED');
		updateSettings({ onlineState: 'offline' });
		
		if (toast.isActive('network_offline')) return;

    toast.error((<small>Internet connection lost. Please check your network settings.</small>), {
      toastId: 'network_offline',
      position: "top-right",
      autoClose: false,
      closeOnClick: false,
      draggable: false,
      theme: 'colored',
      closeButton: false
    });

    return;
  }

  adapt.trigger('ONLINE');
	updateSettings({ onlineState: 'online' });

  try{
    toast.dismiss('network_offline');
  }catch(e){}

  if ( timer ) {
    adapt.trigger('SERVICE_RESTORED');
		console.log('Clearing network timer due to restored connection.');
    clearTimeout(timer);
		timer = null;
  }
}